import { useTheme } from "@emotion/react";
import useStyles from "./styles";
import {
  CircularProgress,
  LinearProgress,
  Paper,
  Typography,
} from "@mui/material";
import { alpha, Box, darken } from "@mui/system";
import { BlurOnOutlined, CheckOutlined } from "@mui/icons-material";
import { isNumber } from "@mui/x-data-grid/internals";
export default function CardsStatusTicketComponet(params) {
  const {
    titleCard = "Aguardando análise",
    valueCard = 0,
    typeCard = 1,
    valueTotal = 100,
    icon: Icon = null,
    loading = false,
  } = params;
  const theme = useTheme();
  const styles = useStyles(theme);

  const percent = (valorTotal, valorCard) => {
    const result = (valorCard * 100) / valorTotal;

    return {
      valuePerct: isNumber(result) ? `${result?.toFixed(0)}%` : "0%",
      valueInt: isNumber(result) ? parseInt(result) : 0,
    };
  };

  const styleCard = {
    1: {
      colorComponent: theme.palette.cardTrafficData.paperColor.statusUp,
      circleDark: theme.palette.colors.green.darker,
      circleLight: theme.palette.colors.green.light,
    },
    2: {
      colorComponent: theme.palette.cardTrafficData.paperColor.inputData,
      circleDark: theme.palette.colors.blue.darker,
      circleLight: theme.palette.colors.blue.medium,
    },
    3: {
      colorComponent: theme.palette.cardTrafficData.paperColor.outputData,
      circleDark: theme.palette.colors.orange.darker,
      circleLight: theme.palette.colors.orange.medium,
    },
    4: {
      colorComponent: theme.palette.cardTrafficData.paperColor.speeData,
      circleDark: alpha(theme.palette.colors.blue.light, 0.2),
      circleLight: alpha(theme.palette.colors.blue.light, 0.7),
    },
    5: {
      colorComponent: theme.palette.colors.orange.darker,
      circleDark: alpha(theme.palette.colors.orange.dark, 0.4),
      circleLight: theme.palette.colors.orange.dark,
    },
    6: {
      colorComponent: theme.palette.colors.blue.dark,
      circleDark: darken(theme.palette.colors.blue.light, 0.4),
      circleLight: alpha(theme.palette.colors.blue.light, 0.7),
    },
    7: {
      colorComponent: theme.palette.colors.yellow.darker,
      circleDark: darken(theme.palette.colors.yellow.dark, 0.5),
      circleLight: theme.palette.colors.yellow.light,
    },
    8: {
      colorComponent: theme.palette.colors.purple.dark,
      circleDark: theme.palette.colors.purple.darker,
      circleLight: alpha(theme.palette.colors.purple.light, 1),
    },
    9: {
      colorComponent: theme.palette.colors.pink.dark,
      circleDark: theme.palette.colors.pink.darker,
      circleLight: theme.palette.colors.pink.light,
    },
    10: {
      colorComponent: darken(theme.palette.colors.gray.dark, 0.1),
      circleDark: theme.palette.colors.gray.darker,
      circleLight: theme.palette.colors.gray.light,
    },
  };

  return (
    <Paper
      sx={{
        ...styles.containerPaper,
        backgroundColor: styleCard[typeCard].colorComponent,
      }}
      elevation={theme.palette.mode == "dark" ? 0 : 3}
    >
      {loading && <LinearProgress sx={styles.linearProgress} />}
      <BlurOnOutlined sx={styles.iconBlur} />

      {Icon && <Icon sx={styles.iconComponent} />}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          marginLeft: "30px",
        }}
      >
        <Box sx={styles.containerCircle}>
          <CircularProgress
            variant="determinate"
            value={100}
            size={50}
            thickness={6}
            sx={{
              ...styles.circleDarker,
              color: styleCard[typeCard].circleDark,
            }}
          />

          <CircularProgress
            variant="determinate"
            value={percent(valueTotal, valueCard)?.valueInt}
            size={50}
            thickness={6}
            sx={{
              ...styles.circleLight,
              color: styleCard[typeCard].circleLight,
            }}
          />

          <Box sx={styles.containerValuePercent}>
            <Typography sx={styles.titleValuePercent}>
              {percent(valueTotal, valueCard)?.valuePerct}
            </Typography>
          </Box>
        </Box>

        <Box sx={styles.containerValueCard}>
          <Typography sx={styles.titleValueCard}>{valueCard}</Typography>
          <Typography sx={styles.titleCard}>{titleCard}</Typography>
        </Box>
      </Box>
    </Paper>
  );
}
